import { IoCartOutline } from "react-icons/io5";
import { Badge, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface BasketComponentProps {
  count: any;
}

const BasketComponent = ({ count }: BasketComponentProps) => {
  const navigate = useNavigate();
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);

  const handleScroll = () => {
    if (tooltipOpen) {
      setTooltipOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tooltipOpen]);

  return (
    <Tooltip
      overlayClassName="takaful--share-tooltip"
      placement="bottom"
      title={"حجوزات غير مدفوعة"}
      open={tooltipOpen}
      onOpenChange={(open) => setTooltipOpen(open)}
    >
      <div
        className="takaful--navbar-profile-icon takaful--basket-icon-profile"
        onClick={() => navigate("/profile", { state: { selectedKey: "s15" } })}
      >
        <Badge
          count={count}
          color="#0273b4"
          styles={{ indicator: { width: 20, height: 20 } }}
          style={{ marginTop: "-0.5rem", marginRight: "-0.4rem" }}
        >
          <IoCartOutline size={28} />
        </Badge>
      </div>
    </Tooltip>
  );
};

export default BasketComponent;
